import { render } from "./ClientInfo.vue?vue&type=template&id=44a8f3d3&scoped=true&ts=true"
import script from "./ClientInfo.vue?vue&type=script&lang=ts"
export * from "./ClientInfo.vue?vue&type=script&lang=ts"

import "./ClientInfo.vue?vue&type=style&index=0&id=44a8f3d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a8f3d3"]])

export default __exports__